import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		lan: 1,
		playerStatus: false,
		audioObj: {
			url: '',//语音地址
			cur: 0,//当前播放时长
			maxTime: 0,//音频时长
			title: '',
			exhibit_num: null,
			id: null
		},
		isplayerplay: null
	},
	mutations: {
		setLan: (state, n) => {
			window.localStorage.setItem('lan', n)
			state.lan = n
		},
		setPlayerType: (state, n) => {
			state.playerStatus = n
		},
		setAudio: (state, n) => {
			state.audioObj = n
		},
		setPlayerPlay: (state, n) => {
			state.isplayerplay = n
		}
	},
});



// WEBPACK FOOTER //
// ./src/store.js